// GroupsTabsFull.jsx
const GroupTabs = ({ activeTab, onTabChange, children, selectedDate, onDateChange, periodStartYear, mode  }) => {
  // Функція для форматування дати у YYYY-MM-DD
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  // Функція для отримання діапазону дат навчального року
  const getAcademicYearRange = () => {
    const startYear = parseInt(periodStartYear);
    const startDate = new Date(startYear, 8, 1); // 1 вересня
    const endDate = new Date(startYear + 1, 7, 31); // 31 серпня
    
    return {
      start: startDate,
      end: endDate
    };
  };

  // Функція для отримання максимальної дати
  const getMaxDate = () => {
    const academicYearRange = getAcademicYearRange();
    const currentDate = new Date();
    
    // Якщо поточна дата раніше за кінець навчального року, то max = поточна дата
    // Якщо навчальний рік закінчився, то max = кінець навчального року
    if (currentDate < academicYearRange.end) {
      return currentDate;
    } else {
      return academicYearRange.end;
    }
  };

  const academicYearRange = getAcademicYearRange();
  const maxDate = getMaxDate();

  return (
    <div className="groupskg-group-tabs">
      <div className="groupskg-tabs-actions">
        <ul className="nav nav-tabs groupskg-nav-tabs small" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'kids' ? 'groupskg-active' : ''}`}
              onClick={() => onTabChange('kids')}
            >
              Діти в групі
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'attendance' ? 'groupskg-active' : ''}`}
              onClick={() => onTabChange('attendance')}
            >
              Відвідування
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'table' ? 'groupskg-active' : ''}`}
              onClick={() => onTabChange('table')}
            >
              Табель
            </button>
          </li>
        </ul>
        
        <div className="groupskg-date-selector" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <label htmlFor="groupskg-date-picker" className="groupskg-small" style={{ margin: 0, whiteSpace: 'nowrap' }}>
            Станом на:
          </label>
          <input
            id="groupskg-date-picker"
            type="date"
            className="groupskg-form-control groupskg-small"
            value={formatDate(selectedDate)}
            onChange={(e) => onDateChange(e.target.value)}
            min={formatDate(academicYearRange.start)}
            max={formatDate(maxDate)}
            style={{ width: 'auto', maxWidth: '140px' }}
            title={`Доступний діапазон: ${formatDate(academicYearRange.start)} - ${formatDate(maxDate)}`}
          />
        </div>
        
        <div className="groupskg-right-links">
          <a href="" onClick={(e)=>{ e.preventDefault(); onTabChange('tarifs') }} >Тарифи</a>
          { (mode=="edit") && <a href="#">Перевести</a>}
        </div>
      </div>
      
      <div className="groupskg-tab-content">
        {children}
      </div>
    </div>
  );
};

export default GroupTabs;